import React from 'react';
import PropTypes from 'prop-types';
import RevealSelection from '../RevealSelection';
import { useSportConfig } from '../../hooks/useSportConfig';
import * as Styled from './styles';

export const AnimationModal = ({ title, selection }) => {
    const { config, SelectionCard, mapSelectionToCardProps } = useSportConfig();

    const heading = config.labels.revealMessage(title);
    const cardProps = mapSelectionToCardProps(selection);

    return (
        <Styled.Modal>
            <Styled.ModalContent>
                <Styled.Heading>{heading}</Styled.Heading>
                <RevealSelection>
                    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                    <SelectionCard {...cardProps} />
                </RevealSelection>
            </Styled.ModalContent>
        </Styled.Modal>
    );
};

AnimationModal.defaultProps = {
    selection: { name: '-', metaData: {} }
};

AnimationModal.propTypes = {
    title: PropTypes.string.isRequired,
    selection: PropTypes.shape({
        name: PropTypes.string,
        metaData: PropTypes.shape({})
    })
};

export default AnimationModal;
